import { ActionButton } from '@react-spectrum/s2';
import { memo, useCallback } from 'react';

import { useImsApiContext } from '@/auth/ImsApiContext.tsx';
import { Section } from '@/layouts/settings/Section';
import { trackEvent } from '@/utils/fullstory';

export const SignOutSection = memo(function SignOutSection() {
	const imsApiContext = useImsApiContext();

	const handleLogout = useCallback(() => {
		trackEvent('Signed Out');
		imsApiContext?.imsApi.logout();
	}, [imsApiContext]);

	return (
		<Section title="Account">
			<div className="flex items-center justify-between">
				<span className="text-sm text-[var(--text-primary)]">
					Sign out of Bridgeway
				</span>
				<ActionButton
					isQuiet
					onPress={handleLogout}
					UNSAFE_className="btn-destructive-quiet"
				>
					Sign out
				</ActionButton>
			</div>
		</Section>
	);
});
